import { Col } from 'react-bootstrap'
import React, { FC, useContext, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { RootState } from '@store/store'
import {
  fetchArticleById,
  selectArticleById,
} from '@editor/store/slices/article.slice'
import { getArticleLoading } from '@editor/store/selectors/article.selector'
import './articleForm.scss'
import {
  EditorContext,
  EditorContextType,
} from '@editor/components/editorContext'

const ArticleForm: FC = () => {
  const { job, dispatch } = useContext(EditorContext) as EditorContextType
  const articleLoading = useSelector(getArticleLoading)
  const article = useSelector((state: RootState) =>
    job?.article ? selectArticleById(state, job.article) : null
  )

  useEffect(() => {
    if (job && !articleLoading) dispatch(fetchArticleById(job.article))
  }, [job])

  return (
    <Col>
      {!!article ? (
        <div style={{ maxHeight: '60vh', overflow: 'scroll' }}>
          <a
            href={article.url}
            className="fst-italic"
            target={'_blank'}
            rel="noreferrer"
          >
            Přejít na článek
          </a>
          <h6 className={'mt-2'}>
            <strong>{article.latest_version?.perex}</strong>
          </h6>
          <div
            dangerouslySetInnerHTML={{
              __html: article.latest_version?.text
                ? article.latest_version?.text
                : '',
            }}
          ></div>
        </div>
      ) : (
        <div>Článek se vygeneruje zde</div>
      )}
    </Col>
  )
}
export default ArticleForm
